"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("../../../assets/styles/config");
exports.StyledButton = styled_components_1.default.button `
  align-items: center;
  background: ${config_1.colors.sidewalk};
  border: 1px solid ${config_1.colors.huron};
  border-radius: 8px;
  display: flex;
  height: 100%;
  margin: 0;
  padding: 16px;
  width: 100%;

  &:hover {
    background: ${config_1.colors.sidewalk};
    border-color: ${config_1.colors.indigo};
    box-shadow: none;
  }

  &:focus {
    background: ${config_1.colors.white};
    border-color: ${config_1.colors.huron};
    box-shadow: 0px 2px 4px rgba(22, 21, 29, 0.1);
  }
`;
